import { getPubAbbr, convertUSD, getCachedEurUsdRateSync } from "@revbox/helpers-fe";
import { TaxonomyModule } from "../../../../../modules/taxonomy";

export function TopBidCellRenderer({ value }) {
    if (!value) {
        return null;
    }

    return (
        <div>
            <span className="text-secondary">{value}</span>
        </div>
    );
}

export function TopBidColumnHeaderTooltipRenderer() {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);
    
    return taxonomy.tooltips.ppc_cluster_column_headers.top_bid;
}

export function TopBidCellTooltipRenderer({ value }) {
    const publisherIdByAbbr = getPubAbbr();
    const taxonomy = TaxonomyModule(publisherIdByAbbr);
    const result = taxonomy.tooltips.ppc_cluster_column_inlines.top_bid;
    const rate = getCachedEurUsdRateSync();
    const top_bid = value.replace('$', '');
    if (!top_bid || top_bid === '-' || +top_bid === 0 || !rate) {
        return result;
    }
    const top_bid_eur = convertUSD(+top_bid, rate);
    const renderCondition = top_bid_eur && top_bid_eur > 0;
    return renderCondition ? result.replace('{top_bid}', top_bid_eur) : result;
}
 